import React from 'react';
import { ItemContainer, ItemContent } from '../../styled.bottomSheetSelector';
import { Body4, Body6 } from '../../../common/typography';
import TransparentChecked from '../../../common/icons/TransparentChecked';
import { IHotelItemProps } from '../../../@types/bottomSheet';
import { HighlightText } from '../HighlightText';

export function HotelItem ({
  hotelData,
  isChecked = false,
  onClick,
  searchWords = [],
}: IHotelItemProps) {
  return (
    <ItemContainer
      onClick={onClick}
      className={isChecked ? 'selectedHotel' : ''}
    >
      <ItemContent>
        <div>
          <Body6 color="eerieBlack">
            <HighlightText
              text={hotelData.brandName}
              searchWords={searchWords}
              isChecked={isChecked}
            />
          </Body6>
          <Body4 color="eerieBlack">
            <HighlightText
              text={hotelData.name}
              searchWords={searchWords}
              isChecked={isChecked}
            />
          </Body4>
        </div>
        {isChecked && <TransparentChecked />}
      </ItemContent>
    </ItemContainer>
  );
}
